<template>
    <table class="kgr-table" :class="{ 'kgr-table--striped': !notStriped }">
        <slot></slot>
    </table>
</template>

<script>
export default {
    props: {
        searching: {
            type: Boolean,
            default: true,
        },
        searchPlaceholder: {
            type: String,
            required: false,
        },
        order: {
            type: Array,
            required: false,
            default: () => [],
        },
        notStriped: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDataTable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            tableData: [],
        };
    },
    mounted() {
        if (this.isDataTable) {
            this.draw();
        }
    },
    methods: {
        getColumnType(columnType) {
            return (columnType === 'date') ? 'de_date' : '';
        },
        draw() {
            const columns = [];
            const children = this.$children.filter((child) => child.$el.nodeName === 'TH');
            for (let i = 0; i < children.length; i++) {
                columns.push({
                    orderable: children[i].sortable,
                    type: this.getColumnType(children[i].type),
                });
            }
            const noDataText = $(this.$el).data('no-data-text') || kgr.i18n.trans('dataTable.noData');
            const table = $(this.$el).DataTable({
                autoWidth: false,
                paging: false,
                info: false,
                searching: this.searching,
                language: {
                    search: '',
                    searchPlaceholder: this.searchPlaceholder || kgr.i18n.trans('dataTable.search'),
                    emptyTable: noDataText,
                    zeroRecords: kgr.i18n.trans('dataTable.zeroRecords'),
                },
                order: this.order,
                columns,
            });
            $(this.$el).data('dt-instance', table);
            $('div.dataTables_filter input').addClass('kgr-input kgr-row dataTable-box');
        },
    },
};
</script>
